import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useRouteContext } from '@tanstack/react-router'
import { LeaDataModel, MutationResponse } from '@/models.ts'
import { fetchAuthenticatedData } from '@/queries/shared'
import { FileStatusEnum, FileSubmission } from '@/models/file-submission.tsx'
export enum MatchLEAStatus {
  UNRESOLVED_ACTIVE_LEA = 0,
  UNRESOLVED_INACTIVE_LEA = 1,
  RESOLVED_MERGED = 2,
  RESOLVED_REJECTED = 3,
  RESOLVED_NO_LONGER_USED = 4,
}
export enum MatchActionType {
  MERGE = 1,
  REJECT = 2,
  UNRESOLVE = 3,
  SYSTEM_MERGE = 4,
  SYSTEM_CLEANUP = 5,
  UNMERGE = 6,
}
export type CSPPIDMatch = {
    Id: number,
    CSPPID: string,
    MatchedCSPPID: string,
    Criteria: string,
    UpdateDate: string,
    CreateDate: string,
}
export type CSPPIDMatchLEA = {
  ESIID: number,
  ReportingLEA: string,
  CSPPIDMatchId: number,
  Status: MatchLEAStatus,
  IsInternal?: boolean,
  Match: CSPPIDMatch,
}
export type CSPPIDMatchAction = {
  Id: number,
  Status: number,
  UserID: string,
  Action: number,
  CreateDate: string,
  MatchLEA: CSPPIDMatchLEA,
}
export function csppidMatchMutationFunctions(
  // Optional. Guarded with `?.` below so callers that don't need the result
  // (e.g. passing null/undefined) no longer crash on a successful mutation.
  setSubmitResult?: (resp: MutationResponse<CSPPIDMatchAction>) => void,
  // Optional failure callback. Fires when the request rejects (e.g. a 500 from
  // the /add endpoint) so callers can stop spinners and surface an error
  // instead of hanging.
  onError?: (error: unknown) => void,
) {
  const leaContext = useRouteContext({ from: '/$leaid' })
  const mutation = useMutation({
    // mutationFn now ONLY performs the request and returns its parsed body.
    // Side effects live in onSuccess/onError so that a throw inside a callback
    // is not misclassified by react-query as a failed mutation (which would
    // otherwise fire onError and show a false "Action Failed" toast).
    mutationFn: ({ urlVal, action_type }: { urlVal: string, action_type: MatchActionType }) => {
      const action: CSPPIDMatchAction = {
        Action: action_type,
      }
      return fetchAuthenticatedData<MutationResponse<CSPPIDMatchAction>>(leaContext, urlVal, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(action)
      })
    },
    onSuccess: (resp) => {
      setSubmitResult?.(resp)
    },
    onError: (error) => {
      console.error(error)
      onError?.(error)
    },
  })
  return {
    mutationState: mutation,
    handleSave: async function (csppid_match_id: number, action_type: MatchActionType) {
      var urlVal = `/json/csppid_match/${leaContext.currentUserOrg.esiIdPath}/${csppid_match_id}/add`
      mutation.mutate({ urlVal, action_type })
    }
  }
}